<template>
  <div>
    <div class="center-t">
      <div class="sp-odt">专利转化指标数据管理</div>
    </div>
    <div class="page-wrap">
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="mini"
        style="margin-bottom:20px"
        @click="handleAdd"
      >添加</el-button>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column type="index" width="55" label="序号" align="center">
          <template slot-scope="scope">
            {{ (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        
        <el-table-column
          prop="metricsYear"
          label="年份"
          width="120"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="licenseCount"
          label="专利许可数量(件)"
          width="160"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="licenseTotalAmount"
          label="专利许可总金额(万元)"
          width="160"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="transferCount"
          label="专利转让数量(件)"
          width="160"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="transferTotalAmount"
          label="专利转让总金额(万元)"
          width="160"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="licensedPatentsCount"
          label="被许可专利数量(件)"
          width="160"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="acquiredPatentsCount"
          label="受让专利数量(含购买、作价入股)(件)"
          width="160"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="industrializedPatentsCount"
          label="专利产业化情况(用于生产出产品并投放于市场的专利件数，包括自实施和许可他人实施的)(件)"
          width="330"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="securitizedPatentsCount"
          label="证券化专利数量(件)"
          width="160"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="securitizationAmount"
          label="证券化金额(万元)"
          width="160"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="otherLoanAmount"
          label="其他方式贷款金额(知识产权质押融资外其他方式贷款、外部投资等)(万元)"
          width="260"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="externalInvestmentAmount"
          label="外部投资金额(万元)"
          width="160"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="patentPledgeLoanAmount"
          label="专利质押融资贷款金额(万元)"
          width="230"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="trademarkPledgeLoanAmount"
          label="商标质押融资贷款金额(万元)"
          width="230"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row.id)"
            >更新</el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
    <transDialog
      :trans_dialogVisible.sync="trans_dialogVisible"
      v-if="trans_dialogVisible"
      :id="id"
      @refresh="getList"
    ></transDialog>
  </div>
</template>
<script>
import { transList, transDelete } from "@/api/index";
import transDialog from "@/views/userpage/components/transDialog";
export default {
  components: { transDialog },
  data() {
    return {
      queryParams: {
        pageSize: 10,
        pageNum: 1
      },
      tableData: [],
      id: "",
      total: 0,
      trans_dialogVisible: false
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      transList({ ...this.queryParams }).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    },
    handleEdit(id) {
      this.id = id;
      this.trans_dialogVisible = true;
    },
    handleAdd() {
      this.id = "";
      this.trans_dialogVisible = true;
    },
    handleDelete(id) {
      this.$confirm("是否确认删除该数据？", "提示", {
        confirmButtonText: "确定删除",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          transDelete([id]).then(res => {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getList();
          });
        })
        .catch(err => {});
    }
  }
};
</script>
<style lang="less" scoped>
</style>